import { Icon } from "@iconify/react/dist/iconify.js"
import { CRRender } from "@comp/crRender"
import { memo } from "react"

const SideBarIcon = ({ icon }) => <CRRender> <Icon icon={icon} className="m-auto" width={20} height={20} /></CRRender>
export default memo(SideBarIcon)